import { BaseApi, Environment } from '@nextroll/ar-base-api';

const alignmentApi = new BaseApi('/api/v1/', {
    environment: (process.env.ENVIRONMENT || 'development') as Environment,
});

/**
 * Get advertisable users
 * @param advertisableEid The user's associated advertisable EID.
 * @param signal Optional abortController signal to be able to cancel the fetch
 */
export const getOrganizationUserEmails = async (
    advertisableEid: string,
    signal?: AbortSignal,
): Promise<string[]> => {
    const organization = (await alignmentApi.get('advertisable/get', { advertisable: advertisableEid }, signal))?.results.organization;
    const users = (await alignmentApi.get('organization/get_users', { organization, _escape: false }, signal))?.results;
    return (users || []).map((user: { email: string }) => user.email);
};
